import { render } from "./TotalHoursHeaderComponent.vue?vue&type=template&id=53d5eae4"
import script from "./TotalHoursHeaderComponent.vue?vue&type=script&lang=js"
export * from "./TotalHoursHeaderComponent.vue?vue&type=script&lang=js"

import "./TotalHoursHeaderComponent.vue?vue&type=style&index=0&id=53d5eae4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__